import {
  Component,
  ElementRef,
  Input,
  inject
} from '@angular/core';

import { BrowserApiService } from '../browser-api.service';

@Component({
  selector: 'preload-rect',
  template: '',
  host: {
    '[class]': 'className',
    '[class.static]': 'static',
    '[hidden]': 'isServer'
  }
})
export class PreloadRectComponent {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input()
  public width?: string;

  @Input()
  public height?: string;

  @Input()
  public className = 'preload';

  @Input()
  public background = '#2c3765';

  @Input()
  public borderRadius?: string;

  @Input()
  public static!: boolean;

  public readonly isServer = inject(BrowserApiService).isServer();

  ngOnInit(): void {
    const host = this.host.nativeElement;

    if(this.width) {
      host.style.width = this.width;
    }

    if(this.height) {
      host.style.height = this.height;
    }

    if(this.borderRadius) {
      host.style.borderRadius = this.borderRadius;
    }

    host.style.backgroundColor = this.background;
  }
}